import React from 'react';
import Reflux from 'reflux';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import { AvatarGroup } from '@shoflo-rundown/polymer.legacy';
import { Row, Col } from 'bootstrap';
import TrackableUserPicker from 'main/components/show/cuesheet/trackableUserPicker.jsx';
import TrackingResumeButton from 'main/components/show/cuesheet/trackingResumeButton.jsx';
import TrackingStopBroadcastButton from 'main/components/show/cuesheet/trackingStopBroadcastButton.jsx';
import UserSessionStore from 'flux/stores/UserSessionStore';
import CuesheetCollabStore from 'flux/stores/cuesheet/CuesheetCollabStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import classNames from 'classnames';
import OverUnderToggler from 'main/components/show/cuesheet/overUnderToggler.jsx';

/**
 * Cuesheet (responsive) Footer
 *
 */
export default React.createClass({
  displayName: 'CuesheetFooter',

  mixins: [
    PureRenderMixin,
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connectFilter(CuesheetStore, 'showId', (st) => st.get('showId')),
    Reflux.connectFilter(CuesheetStore, 'eventId', (st) => st.get('eventId')),
    Reflux.connectFilter(CuesheetStore, 'displayActualDuration', (st) =>
      st.getIn(['show', 'displayActualDuration']),
    ),
    Reflux.connect(CuesheetCollabStore, 'collab'),
  ],

  getDefaultProps() {
    return {
      displayTrackingElements: true,
    };
  },

  render() {
    const { displayActualDuration, eventId, user } = this.state;
    const cuesheetTheme = user.get('cuesheetTheme');
    const trackingResumeLinkCols = {
      lg: 12,
      md: 12,
      sm: 13,
      xs: 23,
      lgOffset: 1,
      mdOffset: 1,
      xsOffset: 1,
    };
    const collaborationCols = { lg: 4, md: 4, sm: 9, xs: 23 };

    let trackingResumeButton = <TrackingResumeButton />;
    let trackableUserPicker = <TrackableUserPicker />;
    let trackingStopBroadcastButton = <TrackingStopBroadcastButton />;

    const { displayTrackingElements, disableLightTheme } = this.props;

    if (!displayTrackingElements) {
      trackingResumeButton = null;
      trackableUserPicker = null;
      trackingStopBroadcastButton = null;
    }

    let lightThemeClasses = { 'cs-footer-light': cuesheetTheme === 'light' };
    if (disableLightTheme) lightThemeClasses = {};

    const avatarGroupNode = this._getAvatarGroupNode();

    return (
      <footer
        id="cs-footer"
        className={classNames('cs-footer', lightThemeClasses)}
      >
        <Row>
          <Col {...trackingResumeLinkCols}>
            {displayTrackingElements ? (
              <span>
                <span className="tracking-resume-link-wrapper">
                  {trackingResumeButton}
                </span>
                {trackableUserPicker}
                <div className="tracking-stop-broadcasting-wrapper">
                  {trackingStopBroadcastButton}
                </div>
                <div className="tracking-stop-broadcasting-wrapper">
                  <OverUnderToggler
                    user={user}
                    eventId={eventId}
                    displayActualDuration={displayActualDuration}
                  />
                </div>
              </span>
            ) : null}
          </Col>
          <Col {...collaborationCols}>{avatarGroupNode}</Col>
        </Row>
      </footer>
    );
  },

  _getAvatarGroupNode() {
    const { collab, showId } = this.state;

    const showCollabItems = collab[showId];

    const users = showCollabItems
      ? showCollabItems.map((item) => {
          const { user, collaboration } = item;
          user.type = collaboration.type;
          return user;
        })
      : null;

    if (users) {
      return (
        <div>
          <AvatarGroup users={users} max={5} />
        </div>
      );
    }

    return null;
  },
});
